import React from 'react'
import LayoutHorizontal from 'src/apps/Global/components/Nav/LayoutHorizontal'
import { Theme } from 'src/libraries/contexts/Theme'

const GlobalNav = () => (
   <>
      <Theme
         globalNavBackgroundColor="#0e1624"
         globalNavBorderColor="#000"
         globalNavDividerColor="#747982"
         globalNavLogoFieldName="logoDefaultNegative"
         globalNavTextColor="#d0dce3"
         viewportMarginLeft="0px"
      />
      <LayoutHorizontal />
   </>
)

export default GlobalNav
